import { useMemo } from 'react'
import type { TabMappings } from '../types'

interface TabRefs {
  detailsContainerRef: React.RefObject<HTMLDivElement>
  faqContainerRef: React.RefObject<HTMLDivElement>
  prizesContainerRef: React.RefObject<HTMLDivElement>
}

export const useTabMappings = (refs: TabRefs): TabMappings =>
  useMemo(
    () => ({
      refs: {
        ['GiveawayDetailsTab']: refs.detailsContainerRef,
        ['GiveawayFaqTab']: refs.faqContainerRef,
        ['GiveawayPrizesTab']: refs.prizesContainerRef,
      },
    }),
    [refs.detailsContainerRef, refs.faqContainerRef, refs.prizesContainerRef],
  )
